// Every word the catalogue shows (UC-30, UC-31), in Arabic, as the Claude
// Design project's Catalogue page draws it. The catalogue is Arabic only, like
// the website; this file is to it what src/i18n is to the app.

import { countForm } from '../help/shelf';

export const brand = {
	name: 'دليل بوصلة',
	tagline: 'مطاعم ومنيوهات',
};

export const nav = {
	label: 'القائمة الرئيسية',
	menu: 'القائمة',
	restaurants: 'المطاعم',
	owners: 'لأصحاب المطاعم',
};

export const home = {
	pageTitle: 'دليل بوصلة — مطاعم ومنيوهات',
	description:
		'مطاعم شغالة على بوصلة ونشرت المنيو بتاعها. دوّر باسم المطعم أو بالمنطقة، وافتح المنيو بأسعار كل فرع.',
	title: 'دوّر على مطعم',
	lead: 'بجزء من اسمه، أو بالمنطقة.',
	searchLabel: 'اسم المطعم أو المنطقة',
	searchPlaceholder: 'مثلًا: زعفران أو الزمالك',
	search: 'دوّر',
	tooLong: 'البحث 80 حرف بالكتير.',
	order: 'مترتبين بالاسم، ومفيش مطعم بيدفع عشان يطلع قبل التاني.',
	empty: 'لسه مفيش مطاعم في الدليل.',
	noMatch: 'مفيش مطعم بالاسم ده أو في المنطقة دي.',
	all: 'كل المطاعم',
	matching: (q: string) => `مطاعم فيها «${q}»`,
	clearSearch: 'امسح البحث',
	pages: 'الصفحات',
	previous: 'اللي قبلها',
	page: 'صفحة',
	next: 'اللي بعدها',
};

export const restaurant = {
	description: (name: string) => `منيو ${name} على دليل بوصلة، بأسعار كل فرع.`,
	back: 'كل المطاعم',
	shopButton: (name: string) => `فرع ${name}`,
	map: 'افتحه على خرائط جوجل',
	/** After a weighed item's price, which is for one kilogram (UC-31.R6). */
	perKilo: '/ كجم',
	empty: 'الفرع ده لسه معندوش أصناف.',
	category: 'القسم',
	allCategories: 'كل الأقسام',
	word: 'دوّر في المنيو',
	categories: 'اختار القسم',
	/** How many items, in the Arabic form for that number. */
	itemCount: (n: number) =>
		({ One: 'صنف واحد', Two: 'صنفين', Few: `${n} أصناف`, Many: `${n} صنف` })[countForm(n)],
	clearFilter: 'امسح الفلتر',
	searchAll: 'دوّر في كل الأقسام',
	filterNone: 'مفيش صنف بالفلتر ده.',
	soldOut: 'خلص',
	note: 'الأسعار زي ما المطعم كاتبها على بوصلة لكل فرع، وممكن تتغيّر.',
	notHere: 'مفيش مطعم على العنوان ده.',
	notHereTitle: 'مش موجود — دليل بوصلة',
	shops: 'اختار الفرع',
	close: 'اقفل',
	current: 'معروض دلوقتي',
	/** The list or cards switch, shown while the shop's menu holds a photo. */
	view: 'طريقة العرض',
	viewList: 'سطور',
	viewCards: 'كروت',
	/** Beside an item that opens: its photo, description or option groups. */
	details: 'التفاصيل',
	/** Under a description cut to three lines in the item's sheet. */
	readMore: 'اقرا أكتر',
	/** A choice that costs nothing extra (the owner's pick on #959). */
	free: '—',
	/** An option group's rule, from its least and most choices. */
	choose: (min: number, max: number) =>
		min === 1 && max === 1
			? 'بتختار واحد'
			: min === 0 && max === 1
				? 'اختياري، واحد بالكتير'
				: min === 0
					? `اختياري، لحد ${max}`
					: min === max
						? `بتختار ${min} بالظبط`
						: `بتختار من ${min} لـ ${max}`,
};

export const down = {
	pageTitle: 'الدليل مش متاح — دليل بوصلة',
	title: 'الدليل مش متاح دلوقتي',
	body: 'جرّب تاني بعد شوية.',
	retry: 'جرّب تاني',
};
